import { render, staticRenderFns } from "./Casesquare.vue?vue&type=template&id=a5d424a2&scoped=true"
import script from "./Casesquare.vue?vue&type=script&lang=js"
export * from "./Casesquare.vue?vue&type=script&lang=js"
import style0 from "./Casesquare.vue?vue&type=style&index=0&id=a5d424a2&prod&lang=css"
import style1 from "./Casesquare.vue?vue&type=style&index=1&id=a5d424a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d424a2",
  null
  
)

export default component.exports